// Snellife racconto home: comparsa allo scroll, testo che si accende, schede prodotti, aggiunta al carrello.
// Più sezioni nella stessa pagina possono includere questo file: ogni radice [data-sh] viene inizializzata una sola volta.
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const cartRoot = window.Shopify?.routes?.root || '/';

  const initReveal = (root) => {
    const revealItems = root.querySelectorAll('[data-sh-reveal]');
    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-in'));
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -5% 0px' }
    );
    revealItems.forEach((item) => observer.observe(item));
  };

  // Manifesto: le parole si accendono man mano che il testo attraversa lo schermo
  const initWords = (root) => {
    const manifesto = root.querySelector('[data-sh-words]');
    if (!manifesto) return;
    const words = [...manifesto.querySelectorAll('.sh-w')];
    if (reduceMotion) {
      words.forEach((word) => word.classList.add('is-lit'));
      return;
    }
    let ticking = false;
    const update = () => {
      ticking = false;
      const bounds = manifesto.getBoundingClientRect();
      const viewport = window.innerHeight;
      const progress = Math.min(1, Math.max(0, (viewport * 0.85 - bounds.top) / (bounds.height + viewport * 0.35)));
      const lit = Math.round(progress * words.length);
      words.forEach((word, index) => word.classList.toggle('is-lit', index < lit));
    };
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };
    // Prima lettura dentro un frame: leggere il layout subito all'avvio forzava un reflow sincrono
    requestAnimationFrame(update);
    if (!('IntersectionObserver' in window)) {
      window.addEventListener('scroll', onScroll, { passive: true });
      return;
    }
    // Il listener di scroll serve solo mentre il manifesto è vicino allo schermo: fuori da lì il risultato
    // è fisso (tutto spento sopra, tutto acceso sotto), basta un aggiornamento all'uscita
    let listening = false;
    new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !listening) {
          window.addEventListener('scroll', onScroll, { passive: true });
          listening = true;
        } else if (!entry.isIntersecting && listening) {
          window.removeEventListener('scroll', onScroll);
          listening = false;
        }
        onScroll();
      },
      { rootMargin: '25% 0px 25% 0px' }
    ).observe(manifesto);
  };

  // Anelli rotanti e nastri sono animazioni infinite: in pausa quando non sono sullo schermo
  const initLoops = (root) => {
    const loops = root.querySelectorAll('.sh-ring, .sh-marquee__track');
    if (!loops.length || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.target.style.animationPlayState = entry.isIntersecting ? 'running' : 'paused';
      });
    });
    loops.forEach((loop) => observer.observe(loop));
  };

  const initTabs = (root) => {
    root.querySelectorAll('[role="tablist"]').forEach((list) => {
      const tabs = [...list.querySelectorAll('[data-sh-tab]')];
      const select = (selected) => {
        tabs.forEach((tab) => {
          const active = tab === selected;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          const panel = document.getElementById(tab.getAttribute('aria-controls'));
          if (!panel) return;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          const step = event.key === 'ArrowRight' ? 1 : -1;
          const next = tabs[(index + step + tabs.length) % tabs.length];
          select(next);
          next.focus();
        });
      });
    });
  };

  // Aggiunta al carrello: apre il cart drawer aggiornato
  const initAddToCart = (root) => {
    root.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-sh-add]');
      if (!button) return;
      event.preventDefault();

      const label = button.querySelector('span');
      const originalLabel = label ? label.textContent : '';
      const drawer = document.querySelector('cart-drawer');
      button.classList.add('is-loading');
      button.disabled = true;

      try {
        const body = { items: [{ id: Number(button.dataset.shAdd), quantity: 1 }] };
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          body.sections = drawer.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
        }
        const response = await fetch(`${cartRoot}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const state = await response.json();
        if (!response.ok || state.status) throw new Error(state.description || state.message);

        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(state);
        } else {
          window.location.href = `${cartRoot}cart`;
          return;
        }

        button.classList.add('is-added');
        if (label) label.textContent = 'Aggiunto';
        setTimeout(() => {
          button.classList.remove('is-added');
          if (label) label.textContent = originalLabel;
        }, 2200);
      } catch (error) {
        console.error(error);
      } finally {
        button.classList.remove('is-loading');
        button.disabled = false;
      }
    });
  };

  document.querySelectorAll('[data-sh]').forEach((root) => {
    if (root.dataset.shReady) return;
    root.dataset.shReady = 'true';
    root.classList.add('sh-js');
    initReveal(root);
    initWords(root);
    initLoops(root);
    initTabs(root);
    initAddToCart(root);
  });
})();
